import _ from 'lodash';
import moment from 'moment';
import Vue from 'vue';
import { HTTP } from '@/utils/http';
import * as actions from '../types/actions';
import * as getters from '../types/getters';
import * as mutations from '../types/mutations';

const defaultService = {
  frequency: 'every',
  weekday: 'Sunday',
  _embedded: {},
};

const parseService = (service) => {
  const dateFields = [
    'end_time',
    'start_time',
  ];
  dateFields.forEach((field) => {
    if (service[field]) {
      service[field] = moment(service[field], moment.ISO_8601).toDate();
    }
  });
  return service;
};

export default {
  actions: {
    async [actions.DO_CREATE_SERVICE]({ commit }, params) {
      const { data } = await HTTP.post('/services', params);
      commit(mutations.SET_SERVICE, data.data.services[0]);
      return data;
    },
    async [actions.DO_DELETE_SERVICE]({ commit }, payload) {
      const { id, ignore } = payload;
      const params = Object.assign({}, payload);
      delete params.id;
      delete params.ignore;
      const { data } = await HTTP.delete(`/services/${id}`, params);
      if (!ignore) commit(mutations.SET_SERVICE, data.data.services[0]);
      return data;
    },
    async [actions.DO_GET_SERVICE]({ commit }, payload) {
      const { id } = payload;
      const params = Object.assign({}, payload);
      delete params.id;
      const { data } = await HTTP.get(`/services/${id}`, { params });
      commit(mutations.SET_SERVICE, data.data.services[0]);
      return data;
    },
    async [actions.DO_GET_SERVICES]({ commit }, params) {
      const { data } = await HTTP.get('/services', { params });
      commit(mutations.SET_SERVICES, data.data.services);
      return data;
    },
    async [actions.DO_UPDATE_SERVICE]({ commit }, payload) {
      const { id } = payload;
      const params = Object.assign({}, payload);
      delete params.id;
      const { data } = await HTTP.patch(`/services/${id}`, params);
      commit(mutations.SET_SERVICE, data.data.services[0]);
      return data;
    },
  },
  getters: {
    [getters.GET_SERVICE]: state => state.service,
    [getters.GET_SERVICES]: state => state.services,
  },
  mutations: {
    [mutations.INSERT_SERVICE](state, payload) {
      const index = _.findIndex(state.services, { id: payload.val.id });
      if (index >= 0) {
        state.services.splice(index, 1);
      }
      state.services.splice(payload.index, 0, payload.val);
    },
    [mutations.SET_SERVICE](state, service) {
      state.service = parseService(service);
    },
    [mutations.SET_SERVICE_FIELD](state, field) {
      const nodes = field.key.split('.');
      let obj = state.service;
      let i = 0;
      nodes.forEach((node) => {
        i += 1;
        if (i === nodes.length) {
          Vue.set(obj, node, field.val);
        } else {
          obj = obj[node];
        }
      });
    },
    [mutations.SET_SERVICES](state, services) {
      state.services = services;
    },
    [mutations.UNSET_SERVICE](state) {
      state.service = _.cloneDeep(defaultService);
    },
  },
  state: {
    service: _.cloneDeep(defaultService),
    services: [],
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/services.js